import { useRouter } from 'next/router';
import { z } from 'zod';
import MostPopularShowcases from '../components/MostPopularShowcases/MostPopularShowcases';
import ShowcasesPageHeader from '../components/ShowcasesPageHeader/ShowcasesPageHeader';

const searchQuery = z.string().optional();

const ShowcasesPage = () => {
  const router = useRouter();
  const search = searchQuery.parse(router.query.search);

  return (
    <>
      {!search && <ShowcasesPageHeader />}
      <MostPopularShowcases search={search} />
    </>
  );
};

export default ShowcasesPage;
